"use client";

import { Form as FormPrimitive } from "@base-ui/react/form";
import type { TenantContextValue } from "@tillix/tenants/react";
import { cn } from "#ui-atoms/lib/utils";

export interface BaseFormProps extends FormPrimitive.Props {
  tenant?: TenantContextValue;
}

function BaseForm({ className, ...props }: BaseFormProps) {
  return (
    <FormPrimitive
      className={cn("flex w-full flex-col gap-4", className)}
      data-slot="form"
      {...props}
    />
  );
}

export { BaseForm };
